<div class="row">
    <div class="col-md-12">
        <!-- <yt-fw-default-list-modal [CondensedTable]="true"></yt-fw-default-list-modal> -->
    </div>
</div>
<!-- <a (click)="loadevents()"> loadevents</a>
<p>Display event : {{displayEvent | json}}</p>
<div *ngIf="calendarOptions">
    <ng-fullcalendar #ucCalendar [options]="calendarOptions" (eventClick)="eventClick($event.detail)" (eventDrop)="updateEvent($event.detail)"
        (eventResize)="updateEvent($event.detail)" (dayClick)="dayClick($event.detail)" (clickButton)="clickButton($event.detail)" [(eventsModel)]="events"></ng-fullcalendar>
</div> -->